import { Injectable, Injector } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
// import * as JSONH from 'jsonh/js/jsonh';
import { ToastrService } from 'ngx-toastr';

import { AppSettings } from './../app.settings';
import { AuthTokenService } from './auth-token.service';

export interface PagingParam {
	pageNumber?: number;
	pageSize?: number;
	rowCount?: number;
}

export interface SuccessResponse<T> {
	data: T;
	rowCount?: number;
	totalCount?: number;
	[prop: string]: any;
}

@Injectable()
export class CommonRequestService {

	public layerNotFoundErr = 'Layer replaced or deleted!';

	private toastr: ToastrService;

	// private defaultHttp: AuthHttp;
	// private alternativeHttp: Http;
	constructor(
		injector: Injector,
		private http: HttpClient,
		private tokenService: AuthTokenService
		// private http: Http,
		// private authHttp: AuthHttp
	) {
		setTimeout(() => {
			this.toastr = injector.get(ToastrService);
		});
		// this.defaultHttp = this.authHttp;
		// this.alternativeHttp = this.http;
	}
	handleHttpRsp(rsp): SuccessResponse<any> {
		const payload = rsp.payload;
		const result: SuccessResponse<any> = {
			data: null
		};
		for (const prop in payload) {
			if (prop !== 'type' && prop !== 'content') {
				result[prop] = payload[prop];
			}
		}
		// if (payload.data.type === 'jsonh') {
		// 	result.data = JSONH.unpack(rsp.content);
		// } else if (rsp.type === 'json') {
		// 	result.data = rsp.content;
		// } else {
		// 	result.data = rsp;
		// }
		return result;
	}
	handleError(err) {
		console.log(err);
		if (err.status === 400) {
			// this.toastr.error(err.message);
		} else if (err.status === 500) {
			const errorDetail = err.error.errorDetail;

			// Hard coded
			if (errorDetail === this.layerNotFoundErr) {
				this.handleLayerNotFoundErr();
			} else {
				// this.toastr.error(errorDetail);
			}
		}
		return Observable.throw(err);
	}
	// requestGet(url: string, options?: RequestOptionsArgs, successCallback?: (d: SuccessResponse<any>) => any, errorCallback?, notDefaultHttp?: boolean) {
	requestGet(url: string, options?, successCallback?: (d: SuccessResponse<any>) => any, errorCallback?, skipAuth?: boolean) {
		// const requester: Http | AuthHttp = notDefaultHttp ? this.alternativeHttp : this.defaultHttp;
		options = options || {};

		if (!skipAuth) {
			if (!options.headers) {
				const headers = new HttpHeaders({
					Authorization: this.tokenService.getToken()
				});
				options.headers = headers;
			}
		}
		return this.http.get(url, options)
		.map(rsp => this.handleHttpRsp(rsp))
		.catch(err => this.handleError(err))
		.subscribe((data: SuccessResponse<any>) => {
			if (successCallback) {
				successCallback(data);
			}
		}, (err) => {
			if (errorCallback) {
				errorCallback(err);
			}
		});

	}
	requestPost(url: string, body, successCallback?, errorCallback?, notDefaultHttp?: boolean, options?) {
		// const requester = notDefaultHttp ? this.alternativeHttp : this.defaultHttp;
		// options = options ? options : new RequestOptions();
		return this.http.post(url, body, options)
		.map(rsp => this.handleHttpRsp(rsp))
		.catch(err => this.handleError(err))
		.subscribe((data) => {
			if (successCallback) {
				successCallback(data);
			}
		}, (err) => {
			if (errorCallback) {
				errorCallback(err);
			}
		});

	}
	requestPut(url: string, body, successCallback?, errorCallback?, notDefaultHttp?: boolean, headers?) {
		// const requester = notDefaultHttp ? this.alternativeHttp : this.defaultHttp;
		return this.http.put(url, body, {
			headers: headers ? headers : new HttpHeaders({'Content-Type': 'application/json'})
		})
		.map(rsp => this.handleHttpRsp(rsp))
		.catch(err => this.handleError(err))
		.subscribe((data) => {
			if (successCallback) {
				successCallback(data);
			}
		}, (err) => {
			if (errorCallback) {
				errorCallback(err);
			}
		});
	}
	requestDelete(url: string, options?, successCallback?, errorCallback?, notDefaultHttp?: boolean) {
		// const requester = notDefaultHttp ? this.alternativeHttp : this.defaultHttp;
		options = options || {};
		return this.http.request('delete', url, options)
		.map(rsp => this.handleHttpRsp(rsp))
		.catch(err => this.handleError(err))
		.subscribe((data) => {
			if (successCallback) {
				successCallback(data);
			}
		}, (err) => {
			if (errorCallback) {
				errorCallback(err);
			}
		});
	}
	setParamsPaging(params, paging: PagingParam) {
		if (paging.pageSize || paging.pageSize === 0) {
			params.pageSize = paging.pageSize.toString();
		}
		if (paging.pageNumber || paging.pageNumber === 0) {
			params.pageNumber = paging.pageNumber.toString();
		}
		if (paging.rowCount || paging.rowCount === 0) {
			params.rowCount = paging.rowCount.toString();
		}
		// if (paging.pageSize || paging.pageSize === 0) {
		// 	params.set('pageSize', paging.pageSize.toString());
		// }
		// if (paging.pageNumber || paging.pageNumber === 0) {
		// 	params.set('pageNumber', paging.pageNumber.toString());
		// }
		// if (paging.rowCount || paging.rowCount === 0) {
		// 	params.set('rowCount', paging.rowCount.toString());
		// }
	}

	private async handleLayerNotFoundErr() {
		await alert('Layer has been updated or deleted. Please refresh.');
		window.open(AppSettings.rootLink + 'azgiv/dashboard', '_self');
	}
}
